/**
 * @generated SignedSource<<6fff919005150130a3067a0438a6d486>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useWidgetTodoSubscriptionUnassignedSubscription$variables = {
  categoryId: string;
  teamIds: ReadonlyArray<string>;
};
export type useWidgetTodoSubscriptionUnassignedSubscription$data = {
  readonly todoUnassignedToTeams: {
    readonly todo: {
      readonly id: string;
    };
  } | null;
};
export type useWidgetTodoSubscriptionUnassignedSubscription = {
  response: useWidgetTodoSubscriptionUnassignedSubscription$data;
  variables: useWidgetTodoSubscriptionUnassignedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "categoryIds.0",
            "variableName": "categoryId"
          }
        ],
        "kind": "ListValue",
        "name": "categoryIds"
      },
      {
        "kind": "Variable",
        "name": "teamIds",
        "variableName": "teamIds"
      }
    ],
    "concreteType": "TodoCreatedPayload",
    "kind": "LinkedField",
    "name": "todoUnassignedToTeams",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTodoSubscriptionUnassignedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTodoSubscriptionUnassignedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4724f4d931d4a406ff1fcba9f530a7f3",
    "id": null,
    "metadata": {},
    "name": "useWidgetTodoSubscriptionUnassignedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTodoSubscriptionUnassignedSubscription(\n  $categoryId: ID!\n  $teamIds: [ID!]!\n) {\n  todoUnassignedToTeams(categoryIds: [$categoryId], teamIds: $teamIds) {\n    todo {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "531e96b306d30a56a0c17209378c9a14";

export default node;
